import React, { FC } from 'react'
import CustomLabel from '../CustomLabel'
import CustomInput from '../CustomInput'
import { TControls } from '../../../features/userInfoForm/types'

const LoanLength: FC<TControls> = ({ control }) => (
  <div>
    <CustomLabel label="Loan length (months)"/>
    <CustomInput
      disabled
      name="loanLength"
      control={control}
    />
  </div>
)

export default LoanLength
